import { render, staticRenderFns } from "./GovernanceEvents.vue?vue&type=template&id=1d8b727f&"
import script from "./GovernanceEvents.vue?vue&type=script&lang=js&"
export * from "./GovernanceEvents.vue?vue&type=script&lang=js&"
import style0 from "./GovernanceEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports